import React, { useEffect, useRef, useState } from "react";
import { Chip, Stack } from "@mui/material";
import "./PublishedHomeworkPreRead.css";
import FilterBox from "../../../pages/On_going/Published_Assessment/Filter_Box/FilterBox";
import { Label, Popup } from "semantic-ui-react";
import PublishAssessBoxPreRead from "../Published/published_access_box/PublishAssessBoxPreRead";
import DraftAssessBoxPreRead from "../Draft/Draft_Assess_Box/DraftAssessBoxPreRead";
import ScheduleAssessBoxPreRead from "../SChedule/Schedule_Assess_box/ScheduleAssessBoxPreRead";
import SubjectBox from "./Published_Subj_Box/SubjectBoxPreRead";
import ImagePopupBox from "../../../../DCM/components/PopUp/ImagePopup/ImagePopupBox";
import PrereadImage from "./../../../../images/PreRead_Process_Flow.png";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PublishedHomeworkPreRead = ({ leftSidebarSize }) => {
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);
  const [openImg, setOpenImg] = useState(false);
  const [activeSubHeader, setActiveSubHeader] = useState(
    localStorage.getItem("buttons"),
  );
  const buttons = localStorage.getItem("buttons");
  localStorage.setItem("buttons", buttons);

  const [unSavedDialog, setUnSavedDialog] = useState(false);

  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    searchvalue: "",
    standard_id: "",
    section_id: "",
  });

  const [ispopupopen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);

  const handlePopupClick = (event) => {
    event.stopPropagation();
    setIsPopupOpen(!ispopupopen);
  };

  const togglePopup = () => {
    setIsPopupOpen(!ispopupopen);
  };

  let sectionArr = [];
  let standardArr = [];

  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };
  dropDownHelper();
  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }

    generalRole_JSON?.map((obj) => {
      // if (obj?.standard_id?.id === filter?.standard_id) {
      addUniqueObjectToArraysect(obj.section_id);
      // }
    });
    classTeacher_JSON?.map((obj) => {
      // if (obj?.standard_id?.id === filter?.standard_id) {
      addUniqueObjectToArraysect(obj.section_id);
      // }
    });
    cordinator_JSON?.map((obj) => {
      // if (obj?.standard_id?.id === filter?.standard_id) {
      addUniqueObjectToArraysect(obj.section_id);
      // }
    });
  };
  handleDropDownSec();

  const savedPreReadDAta = JSON.parse(
    localStorage.getItem("prereadStateLocal"),
  );

  console.log("savedPreReadDAta", savedPreReadDAta);
  const CheckSavedData = () => {
    if (savedPreReadDAta) {
      setUnSavedDialog(true);
    } else {
      navigate("/createPreRead");
    }
  };

  const handleContinueSaved = () => {
    setUnSavedDialog(false);
    if (savedPreReadDAta) {
      navigate("/createPreRead");
    }
  };

  const handleCreateNew = () => {
    localStorage.removeItem("prereadStateLocal");
    navigate("/createPreRead");
  };

  const renderAppliedFilters = () => {
    const chips = [];

    if (filter.searchvalue) {
      chips.push({
        label: `Search: ${filter.searchvalue}`,
        key: "search",
        onDelete: () => setFilter((prev) => ({ ...prev, searchvalue: "" })),
      });
    }

    if (filter.standard_id) {
      chips.push({
        label: `Class - ${standardArr.find((std) => std.id === filter.standard_id)?.name || ""}`,
        key: "class",
        onDelete: () =>
          setFilter((prev) => ({ ...prev, standard_id: "", section_id: "" })),
      });
    }

    if (filter.section_id) {
      chips.push({
        label: `Section - ${sectionArr.find((sec) => sec.id === filter.section_id)?.name || ""}`,
        key: "section",
        onDelete: () => setFilter((prev) => ({ ...prev, section_id: "" })),
      });
    }

    if (filter.subjectId?.length > 0) {
      chips.push({
        label: `Subjects (${filter.subjectId.length})`,
        key: "subjects",
        onDelete: () => setFilter((prev) => ({ ...prev, subjectId: [] })),
      });
    }

    if (filter.time) {
      chips.push({
        label: `Time: ${filter.time}`,
        key: "time",
        onDelete: () => setFilter((prev) => ({ ...prev, time: "" })),
      });
    }
    if (filter.date) {
      const formattedDate = new Date(filter.date).toLocaleDateString("en-GB");

      chips.push({
        label: `Date: ${formattedDate}`,
        key: "date",
        onDelete: () => setFilter((prev) => ({ ...prev, date: "" })),
      });
    }

    return chips;
  };
  return (
    <>
      <div className=" h-100 ">
        <span className=" hw_main_page_heading">Subject-wise Pre-read</span>
        <div
          className={` ${leftSidebarSize === 70 ? "expand" : "collapasess"}`}
        >
          <SubjectBox filter={filter} />
        </div>

        <div className="main_button_box" style={{ position: "relative" }}>
          <div className="col-md-5 d-flex align-items-center justify-content-between">
            <div className="hw_main_page_heading">Pre-read</div>
          </div>

          <div className="col-lg-6 col-md-7 gap-3 search_filter_box">
            <div className="col-12 col-md-6 p-0  ">
              <img
                className="preread_search_icon"
                src="/images/search icon.svg"
                alt=""
              />
              <input
                className="form-control mr-sm-2 m-0 fontStylePre"
                type="search"
                placeholder="Search by Pre-read Name"
                aria-label="Search"
                maxLength={30}
                onChange={(e) => {
                  setFilter({
                    ...filter,
                    searchvalue: e.target.value,
                  });
                }}
              />
            </div>

            <Popup
              on="click"
              position="bottom center"
              open={ispopupopen}
              onOpen={() => setIsPopupOpen(true)}
              onClose={() => setIsPopupOpen(false)}
              style={{ zIndex: 9999 }} // 🔥 important
              content={
                <div style={{ zIndex: 9999 }}>
                  <FilterBox
                    setFilter={setFilter}
                    filter={filter}
                    setIsPopupOpen={setIsPopupOpen}
                  />
                </div>
              }
              trigger={
                <div className="col-md-2 col-12 filter_box">
                  <img className="filter_img" src="/images/filter_icon.svg" />
                  <span>Filter</span>
                </div>
              }
            />

            <div
              className=" col-md-3 col-12 gap-2  published_add_assessment"
              onClick={() => {
                CheckSavedData();
                localStorage.setItem("ActiveBtn", "");
              }}
            >
              <img className="filter_icon" src="/images/add icon.svg" alt="" />
              <span>Add Pre-read</span>
            </div>
          </div>
        </div>
        {/* <div className="col-12 d-flex align-items-center justify-content-between  mt-3 ">
          <div className="m-0 p-0 col-lg-3 col-md-4 col-5 published_schedule_draft  "> */}
        <div
          className=" d-flex align-items-center buttonsAndDrop  justify-content-between "
          style={{ paddingRight: "1rem" }}
        >
          <div className="m-1 p-0 col-6 col-md-3 d-flex align-items-center  ">
            <>
              <button
                className={` ${
                  // activeSubHeader === "Published"
                  buttons === "Published"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={(e) => {
                  setActiveSubHeader("Published");

                  // setFilter({
                  //   ...filter,
                  //   subjectId: [],
                  //   date: "",
                  //   time: "",
                  // });
                  localStorage.setItem("buttons", "Published");
                }}
              >
                Published
              </button>
              <button
                className={` ${
                  // activeSubHeader === "Draft"
                  buttons === "Draft"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={(e) => {
                  setActiveSubHeader("Draft");

                  // setFilter({
                  //   ...filter,
                  //   subjectId: [],
                  //   date: "",
                  //   time: "",
                  // });
                  localStorage.setItem("buttons", "Draft");
                }}
              >
                Draft
              </button>
              {/* <button
                className={` ${
                  buttons === "Scheduled" ? " three_btnsActive " : "three_btns "
                }`}
                onClick={(e) => {
                  setActiveSubHeader("Scheduled");

                  setFilter({
                    ...filter,
                    subjectId: [],
                    date: "",
                    time: "",
                  });
                  localStorage.setItem("buttons", "Scheduled");
                }}
              >
                Scheduled
              </button> */}
            </>
          </div>

          <Alert
            icon={<InfoOutlinedIcon fontSize="small" />}
            severity="info"
            onClick={() => setOpenImg(true)}
            sx={{
              fontSize: "0.8rem",
              cursor: "pointer",
              width: "fit-content",
              padding: "4px 8px",
              "&:hover": {
                backgroundColor: "#e3f2fd", // hover effect
              },
            }}
          >
            Click to Know Details
          </Alert>

          <div className="m-0 mt-1 p-0 col-6 gap-2 col-md-4 mt-3 d-flex align-items-center">
            {/* Class Select */}
            <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
              <InputLabel>Select Class</InputLabel>
              <Select
                label="Select Class"
                value={filter.standard_id}
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    standard_id: e.target.value,
                    section_id: "",
                  })
                }
              >
                <MenuItem value="">Select Class</MenuItem>
                {standardArr?.length > 0 &&
                  [...standardArr]
                    .sort((a, b) => {
                      const aNum = Number(a.name);
                      const bNum = Number(b.name);

                      const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                      if (bothNumeric) {
                        return aNum - bNum; // numeric sort
                      }

                      return a.name.localeCompare(b.name); // alphabetical sort
                    })
                    .map((standard, index) => (
                      <MenuItem
                        key={index}
                        value={standard?.id}
                        name={standard?.name}
                      >
                        {standard?.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>

            {/* Section Select */}
            <FormControl size="small" fullWidth sx={{ minWidth: 150, ml: 2 }}>
              <InputLabel>Select Section</InputLabel>
              <Select
                label="Select Section"
                value={filter.section_id}
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    section_id: e.target.value,
                  })
                }
                disabled={!filter.standard_id} // Class select hone ke pehle disable
              >
                <MenuItem value="">Select Section</MenuItem>
                {sectionArr &&
                  sectionArr.length > 0 &&
                  sectionArr
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((obj) => (
                      <MenuItem key={obj.id} value={obj.id}>
                        {obj.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
          </div>
        </div>
        {renderAppliedFilters().length > 0 && (
          <div
            style={{
              marginTop: "2px",
              padding: "6px 12px",
              background: "#f8fafc",
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
            }}
          >
            {/* Heading */}
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                color: "#475569",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Applied Filters
            </Typography>

            {/* Chips */}
            <Stack
              direction="row"
              spacing={1}
              flexWrap="wrap"
              sx={{
                gap: 1,
                maxHeight: "60px",
                overflowY: "auto",
              }}
            >
              {renderAppliedFilters().map((chip) => (
                <Chip
                  key={chip.key}
                  label={chip.label}
                  onDelete={chip.onDelete}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{
                    borderRadius: "16px",
                    fontSize: "12px",
                    backgroundColor: "#fff",
                  }}
                />
              ))}
            </Stack>

            <Typography
              onClick={() =>
                setFilter({
                  subjectId: [],
                  date: "",
                  time: "",
                  searchvalue: "",
                  standard_id: "",
                  section_id: "",
                })
              }
              sx={{
                fontSize: "12px",
                color: "#ef4444",
                cursor: "pointer",
                textAlign: "right",
              }}
            >
              Clear All
            </Typography>
          </div>
        )}

        <div className="mt-3 published_preRead_conatainer">
          <div
            className="d-flex flex-wrap  box_gap_preread orange-scrollBar  w-100 "
            style={{
              maxHeight: "280px",
              overflowY: "scroll",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            {activeSubHeader === "Published" && (
              <PublishAssessBoxPreRead filter={filter} />
            )}
            {activeSubHeader === "Draft" && (
              <DraftAssessBoxPreRead filter={filter} />
            )}
            {activeSubHeader === "Scheduled" && (
              <ScheduleAssessBoxPreRead filter={filter} />
            )}
          </div>

          {openImg && (
            <ImagePopupBox setOpenImg={setOpenImg} imgSrc={PrereadImage} />
          )}
        </div>

        <Dialog open={unSavedDialog} onClose={() => setUnSavedDialog(false)}>
          <DialogTitle>Unsaved Changes Found</DialogTitle>
          <DialogContent>
            <Typography>
              You already have an unsaved Pre-read –{" "}
              <Typography
                component="span"
                sx={{
                  fontWeight: "bold",
                  color: "error.main",
                  textDecoration: "underline",
                }}
              >
                {savedPreReadDAta?.tittle}
              </Typography>
              . Do you want to continue with it or start a new one?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setUnSavedDialog(false)}
              color="primary"
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              onClick={handleContinueSaved}
              color="primary"
              variant="outlined"
            >
              Continue Saved
            </Button>
            <Button onClick={handleCreateNew} color="error" variant="contained">
              Create New
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default PublishedHomeworkPreRead;
